import { Link } from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"

export const RouterLink = ({ to = "", ...rest }) => {
  return <Link as={ReactRouterLink} to={to} {...rest} />
}
